import PropTypes from 'prop-types';
import './ChallengeGoals.css';

const formatNumber = (value) => new Intl.NumberFormat().format(value ?? 0);

/**
 * Goal bars for the running challenge (WS4).
 *
 * Deliberately separate from GoalProgressBars, which renders the three
 * lifetime SiteGoals with bespoke widgets per key. These are season goals:
 * same shape every time, measured inside the challenge window.
 */
const ChallengeGoals = ({ goals = [], challengeName }) => {
  if (goals.length === 0) return null;

  return (
    <section className="challenge-goals">
      <h2 className="challenge-goals-title">
        {challengeName ? `${challengeName} goals` : 'Challenge goals'}
      </h2>

      <div className="challenge-goals-list">
        {goals.map(goal => (
          <div
            key={goal.id || goal.key}
            className={`challenge-goal ${goal.isCompleted ? 'completed' : ''}`}
          >
            <div className="challenge-goal-header">
              <span className="challenge-goal-name">{goal.name}</span>
              <span className="challenge-goal-value">
                {formatNumber(goal.currentValue)}
                <span className="challenge-goal-target">
                  {' '}/ {formatNumber(goal.targetValue)}
                  {goal.unit ? ` ${goal.unit}` : ''}
                </span>
                {goal.isCompleted && <span className="challenge-goal-done"> 🎉</span>}
              </span>
            </div>

            <div
              className="challenge-goal-track"
              role="progressbar"
              aria-valuenow={goal.progress}
              aria-valuemin={0}
              aria-valuemax={100}
              aria-label={goal.name}
            >
              <div
                className="challenge-goal-fill"
                style={{ width: `${Math.min(goal.progress ?? 0, 100)}%` }}
              />
            </div>

            <div className="challenge-goal-footer">
              {goal.isCompleted
                ? 'Goal reached'
                : `${formatNumber(goal.remaining)} to go`}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

ChallengeGoals.propTypes = {
  goals: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    key: PropTypes.string,
    name: PropTypes.string,
    currentValue: PropTypes.number,
    targetValue: PropTypes.number,
    unit: PropTypes.string,
    progress: PropTypes.number,
    remaining: PropTypes.number,
    isCompleted: PropTypes.bool
  })),
  challengeName: PropTypes.string
};

export default ChallengeGoals;
